import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Label,
	FormGroup,
	Input
} from 'reactstrap';
import { toast } from 'react-toastify';
import copy from 'clipboard-copy';
import { LoaderObjeto } from '~/components/Loaders';
import ReactGA from 'react-ga4';

import { Text } from '~/components/Text';
import { symbolPriceFormatter } from '~/helpers/price';
import * as ActionsLinks from '~/store/modules/client/maquinaVirtual/actions';
import { PGMContext } from '~/context/PGMContext';

export function ModalGerarLink(props) {
	const { isOpen, toggle, link, simulacao, button } = props;
	const {
		getCupom, authToken
	} = useContext(PGMContext);
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const { linkSimples } = useSelector((state) => state.clientMaquinaVirtual);
	const [body, setBody] = useState({});
	const [valorParcela, setValorParcela] = useState('');

	function handlerGerarLink() {
		handleClickGerarLinkGA4();

		const data = {
			amount: button.pagamentoCliente && button.parcelaCliente ? simulacao.valor : link.valor_digitado,
			customer_choose_installment: !!link.escolha_cliente,
			amount_per_installment: link.escolha_cliente && simulacao.lista[0] ? simulacao.lista[1].valor_parcela : valorParcela,
			client_document: user.dados.documento,
			recurrence_type: null,
			recurrent_payment: false,
			title: body.title,
			...(link.escolha_cliente ? {
				customer_choose_installment: true
			} : {
				installments: Number(link.opcao.replace('x', ''))
			})
		}

		if(body.cupom){
			data.split_data = {
				customer_pgm: body.cupom
			}
		}

		dispatch(
			ActionsLinks.requestGerarLink(data, user)
		);
	}

	function handlerCopy(item) {
		copy(item.checkout_link);
		handleClickCopiarLinkGA4();
		toast.success('Link copiado');
	}

	const handleClose = () => dispatch(ActionsLinks.clearLink());

	useEffect(() => {
		if (link.opcao) {
			setValorParcela(simulacao.lista.filter(lista => lista.opcao === link.opcao)[0].valor_parcela)
		}
	}, [link]);

	useEffect(() => {
		if (user.dados.documento && user.dados.gateway_token) {
			authToken().then((res) => {
				if(res.data.id_token){
					getCupom(user.dados.documento, res.data.id_token).then((response) => {
						if(response?.data?.relacoes[0]?.cupom_fiscal){
							setBody({...body, cupom: response.data.relacoes[0].cupom_fiscal})
						}
					})
				}
			});
		}
		window.addEventListener('beforeunload', handleClose);
		window.addEventListener('unload', handleClose);

		return () => {
			window.removeEventListener('beforeunload', handleClose);
			window.removeEventListener('unload', handleClose);
		};
	}, []);

	function handleClickGerarLinkGA4() {
		ReactGA.event({
			category: "gerar_link_popup_click",
			action: "Gerar Link Popup Flex",
			label: "Gerando Link de Pagamento Popup Flex",
		});
	}

	function handleClickCopiarLinkGA4() {
		ReactGA.event({
			category: "copiar_link_gerado_click",
			action: "Copiar link gerado",
			label: "Salvando link gerado (Copiar Link)",
		});
	}

	return (
		<Modal isOpen={isOpen} toggle={toggle} onClosed={handleClose}>
			{linkSimples.status === null ? (
				<>
					<ModalHeader>Geração de Link de Pagamento</ModalHeader>
					<ModalBody>
						<FormGroup>
							<Label>Título</Label>
							<Input
								type="text"
								onChange={(input) =>
									setBody({
										...body,
										title: input.target.value,
									})
								}
							/>
						</FormGroup>
						<Row className="py-4 border-bottom">
							<Col className="d-flex align-items-center">
								<Text
									weight="bold"
									color="gray"
									className="ml-2">
									Valor total
								</Text>
							</Col>
							<Col className="d-flex align-items-center">
								<Text
									weight="bold"
									color="gray"
									className="mr-2">
									{symbolPriceFormatter(
										Math.trunc(button.pagamentoCliente && button.parcelaCliente ? simulacao.valor : link.valor_digitado) / 100
									)}
								</Text>
							</Col>
						</Row>
						{link.escolha_cliente ? (
							<Row className="py-4 border-bottom">
								<Col className="d-flex align-items-center">
									<Text
										weight="bold"
										color="gray"
										className="ml-2">
										Parcelas
									</Text>
								</Col>
								<Col className="d-flex align-items-center">
									<Text
										weight="bold"
										color="gray"
										className="mr-2">
										A critério do cliente
									</Text>
								</Col>
							</Row>
						) : (
							<>
								<Row className="py-4 border-bottom">
									<Col className="d-flex align-items-center">
										<Text
											weight="bold"
											color="gray"
											className="ml-2">
											Parcelas
										</Text>
									</Col>
									<Col className="d-flex align-items-center">
										{/* <FormGroup>
											<Input
												type="select"
												value={parcela}
												onChange={(input) => {
													setParcela(input.target.value),
														setValorParcela(
															simulacao.lista.filter(lista => lista.opcao === input.target.value)[0].valor_parcela
														)
												}}>
												<option value="">
													Selecione
												</option>
												<option value="1x">A vista</option>
												<option value="2x">2x</option>
												<option value="3x">3x</option>
												<option value="4x">4x</option>
												<option value="5x">5x</option>
												<option value="6x">6x</option>
												<option value="7x">7x</option>
												<option value="8x">8x</option>
												<option value="9x">9x</option>
												<option value="10x">10x</option>
												<option value="11x">11x</option>
												<option value="12x">12x</option>
											</Input>
										</FormGroup> */}
										<Text
											weight="bold"
											color="gray"
											className="mr-2">
											{link.opcao}
										</Text>
									</Col>
								</Row>
								<Row className="py-4">
									<Col className="d-flex align-items-center">
										<Text
											weight="bold"
											color="gray"
											className="ml-2">
											Valor parcelas
										</Text>
									</Col>
									<Col className="d-flex align-items-center">
										{link.opcao &&
											<Text
												weight="bold"
												color="gray"
												className="mr-2">
												{symbolPriceFormatter(
													Math.trunc(simulacao.lista.filter(lista =>
														((lista.opcao === link.opcao) && lista.tipo_operacao_str !== 'Débito'))[0].valor_parcela) / 100)
												}
											</Text>
										}
									</Col>
								</Row>
							</>
						)}
					</ModalBody>
					<ModalFooter>
						<Button onClick={toggle} color="secondary my-0">
							Fechar
						</Button>
						<Button
							disabled={linkSimples.loading}
							onClick={() => handlerGerarLink()}
							color="primary">
							{linkSimples.loading
								? 'Gerando o link'
								: 'Gerar link'}
						</Button>
					</ModalFooter>
				</>
			) : (
				<>
					<ModalHeader>
						<div className="d-flex justify-content-between">
							<span>Seu link foi gerado com sucesso</span>
						</div>
					</ModalHeader>
					<ModalBody>
						<LoaderObjeto
							loading={linkSimples.loading}
							obj={linkSimples.dados}
							error={linkSimples.error}>
							<div style={{ wordWrap: 'break-word' }}>
								<a href={linkSimples.dados.checkout_link} target="_blank" rel="noreferrer">
									{linkSimples.dados.checkout_link}
								</a>
							</div>
							<div className="d-flex justify-content-center">
								<Button onClick={toggle} color="secondary">
									Fechar
								</Button>
								<Button
									color="primary"
									onClick={() =>
										handlerCopy(linkSimples.dados)
									}>
									Copiar link
								</Button>
							</div>
						</LoaderObjeto>
					</ModalBody>
				</>
			)}
		</Modal>
	);
}
